import React from 'react';

const Input = React.forwardRef(({
  type = 'text',
  label,
  placeholder,
  value,
  onChange,
  error,
  helper,
  disabled = false,
  required = false,
  id,
  ariaLabel,
  ariaDescribedBy,
  ...props
}, ref) => {
  const errorId = error ? `${id}-error` : undefined;
  const helperId = helper && !error ? `${id}-helper` : undefined;
  const describedBy = [ariaDescribedBy, errorId, helperId].filter(Boolean).join(' ') || undefined;

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">
          {label}
          {required && <span className="text-error-600 dark:text-error-500 ml-1" aria-label="مطلوب">*</span>}
        </label>
      )}
      <input
        ref={ref}
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        aria-label={ariaLabel || label}
        aria-invalid={!!error}
        aria-describedby={describedBy}
        aria-required={required}
        className={`
          w-full px-4 py-2 border rounded-lg font-medium transition-all duration-200
          focus:outline-none focus:ring-2 focus:ring-offset-0
          dark:bg-gray-800 dark:text-white dark:placeholder-gray-400
          ${error
            ? 'border-error-500 dark:border-error-500 focus:ring-error-500 bg-error-50 dark:bg-error-950'
            : 'border-gray-300 dark:border-gray-600 focus:ring-primary-500'
          }
          ${disabled ? 'bg-gray-100 dark:bg-gray-700 cursor-not-allowed opacity-60' : 'bg-white'}
        `}
        {...props}
      />
      {error && (
        <p id={errorId} className="mt-1 text-sm text-error-600 dark:text-error-500" role="alert">
          {error}
        </p>
      )}
      {helper && !error && (
        <p id={helperId} className="mt-1 text-sm text-gray-600 dark:text-gray-400">
          {helper}
        </p>
      )}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;
